import { Component, OnInit } from '@angular/core';

import { VERSION } from '../_constants/constants';
import { AgentProfileService } from '../_services/agent.profile.service';

import { TranslatePipe } from '../shared/translate/translate.pipe';
import { TranslateService } from '../_services/translate.service';
import { TimezoneService } from '../_services/timezone.service';

declare var $: any;

@Component({
  selector: 'site-header',
  templateUrl: './site-header.component.html',
  providers: [TranslatePipe,TimezoneService]
})
export class SiteHeaderComponent implements OnInit {
  agentProfileService: AgentProfileService;
  version = VERSION.CURRENT;
  language:string;
  languageList:any = [];
  zoneList:any=[];
  timezoneService: TimezoneService;
  defaultZone:string=null;
  constructor(agentProfileService: AgentProfileService, private translate: TranslateService, private translatePipe: TranslatePipe,timezoneService:TimezoneService ) {
    this.agentProfileService = agentProfileService;
    this.timezoneService=timezoneService;             
  }

  ngOnInit(): void {
  
  	let selectedLanguage = localStorage.getItem('language') ? localStorage.getItem('language') : "GB";
    localStorage.setItem('language',selectedLanguage);
  	this.language = selectedLanguage;
  	this.languageList = this.agentProfileService.getTeams();
    this.zoneList=this.agentProfileService.getZoneLIst();
    this.defaultZone=this.timezoneService.getZone(); 
    $('#lang-select').attr('data-selected-country', this.language);


    $('#lang-select').flagStrap({
      countries: {
        "AL": "Albanian (AL)",
        "NL": "Dutch (NL)",
        "IE": "English (IE)",
        "ZA": "English (ZA)",
        "GB": "English (GB)",
        "DE": "German (DE)",
        "GR": "Greek (GR)",
        "HU": "Hungarian (HU)",
        "IS": "Icelandic (IS)",
        "IT": "Italian (IT)",
        "MT": "Maltese (MT)",
        "PT": "Portugese (PT)",
        "RO": "Romanian (RO)",
        "ES": "Spanish (ES)"
      },
      inputName: 'country',
      onSelect: (value, element) => {
       
        this.language = value;
        localStorage.setItem('language', value);
        this.translate.use(value);
        

      if ($('#lang-select-opco').attr('data-selected-country') === ""){

          setTimeout( () => {
              $('.opco-flag-drop .lang-select .opco-dropdown-btn span:first').text(this.translatePipe.transform('HEADING', 'OPCOVIEWLABELS'));
          },500);


          //VICC-622
          $('.opco-flag-drop .lang-select .opco-dropdown-btn span:first').text(this.translatePipe.transform('HEADING', 'OPCOVIEWLABELS'));

        }
        
        setTimeout(() => {
          $("#search-customer-form input[name=searchInput]").attr("title", this.translatePipe.transform("REQUIRED_FIELD", 'CLIENT_SIDE_VALIDATION_ERROR'));


          if (this.agentProfileService.loadAgentProfile()) {

            this.agentProfileService.updatePermissionError(this.translatePipe.transform('FORBIDDEN', 'API_ERROR'));
          }


          
        }, 100);
      },
      placeholder: false
    });

  }
  onChangezone(event):void{
   this.timezoneService.setZone(event.target.value);
    this.timezoneService.setCreated_date(event.target.value, localStorage.getItem('createdDate')); 
    this.timezoneService.setModified_date(event.target.value, localStorage.getItem('ModifieddDate')); 
  }
  onChange(event): void {
    this.language = event.target.value;
    localStorage.setItem('language', event.target.value);
    this.translate.use(this.language);  
  }
}


// WEBPACK FOOTER //
// ./src/app/site-header/site-header.component.ts